import { z } from 'zod';

export const CreatePricingRuleInputSchema = z.object({
  gymId: z.string().uuid().optional(),
  name: z.string().min(1).max(200),
  tier: z.enum(['STANDARD', 'OFF_PEAK', 'PEAK', 'LATE_NIGHT']),
  priceInSmallestUnit: z.number().int().min(0),
  currency: z.string().length(3).toUpperCase(),
  dayOfWeek: z.number().int().min(0).max(6).optional(),
  startTime: z
    .string()
    .regex(/^\d{2}:\d{2}$/)
    .optional(),
  endTime: z
    .string()
    .regex(/^\d{2}:\d{2}$/)
    .optional(),
  priority: z.number().int().min(0).default(0),
  effectiveMode: z.enum(['IMMEDIATE', 'NEXT_DAY']).default('IMMEDIATE'),
});

export const UpdatePricingRuleInputSchema = CreatePricingRuleInputSchema.partial();

export type CreatePricingRuleInput = z.infer<typeof CreatePricingRuleInputSchema>;
export type UpdatePricingRuleInput = z.infer<typeof UpdatePricingRuleInputSchema>;
